<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Confirm Date"
      text="Update confirm date"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="confirmDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="confirmationDateDisplay"
                    data-vv-name="confirm date"
                    outlined
                    readonly
                    label="Confirm Date"
                    class="label-position" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>

                    <template v-slot:append>
                      <v-btn
                        v-if="localConfirmDate != null"
                        class="mb-3"
                        icon
                        @click="clearConfirmDate"
                      >
                        <v-icon color="red">
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localConfirmDate"
                  :min="joinDate"
                  @input="confirmDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      confirmDate: {
        type: String,
        default: null,
      },
      joinDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localConfirmDate: null,
        loading: false,
        toClearConfirmDate: false,
        confirmDateMenu: false,
      }
    },
    computed: {
      confirmationDateDisplay () {
        return this.localConfirmDate ? this.$moment(this.localConfirmDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localConfirmDate = this.confirmDate

        this.loading = false
      },
    },
    methods: { 
      clearConfirmDate () {
        this.localConfirmDate = null
        this.toClearConfirmDate = true
      },
      submitForm () {
        this.setProgressing(true)

        this.$api.jobDetails().update(this.employeeUid, this.prepareFormData())
          .then(response => {
            if (response.status === 200) {
              this.$emit('updated')
              this.$snack({ message: 'Employee confirm date updated' })

              this.setProgressing(false)
              this.dialog = false
            }
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          confirmed_date: this.localConfirmDate,
          to_remove_confirmed_date: this.toClearConfirmDate,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background: white;
}
</style>
